import React, { Suspense, useEffect } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './index.css'

import { CSpinner, useColorModes } from '@coreui/react';
import './scss/style.scss';

// Containers
// const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'));
import DefaultLayout from './layout/DefaultLayout';

// Pages
// const Register = React.lazy(() => import('./views/pages/register/Register'));
// const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
// const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));
// const LoginPage = React.lazy(() => import('./views/pages/login/loginPage'));
import LoginPage from './views/pages/login/loginPage';
import Page404 from './views/pages/page404/Page404';
import Page500 from './views/pages/page500/Page500';
import Register from './views/pages/register/Register';

const App = () => {
  const { isColorModeSet, setColorMode } = useColorModes('coreui-free-react-admin-template-theme');

  const storedTheme = useSelector((state) => state.ui.theme);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.href.split('?')[1]);
    const theme = urlParams.get('theme') && urlParams.get('theme').match(/^[A-Za-z0-9\s]+/)[0];
    if (theme) {
      setColorMode(theme);
    }

    if (isColorModeSet()) {
      return;
    }

    setColorMode(storedTheme);
  }, [isColorModeSet, setColorMode, storedTheme]);

  const ProtectedRoute = ({ element }) => {
    const roles = JSON.parse(localStorage.getItem('roles'))?.roles?.role || '';

    if (roles) {
      return element;
    } else {
      return <LoginPage />;
    }
  }

  return (
    <HashRouter>
      {/* <Suspense
        fallback={
          <div className="pt-3 text-center">
            <CSpinner color="primary" variant="grow" />
          </div>
        }
      > */}
        <Routes>
          <Route exact path="/login" name="Login Page" element={<LoginPage />} />
          {/* <Route exact path="/register" name="Register Page" element={<Register />} /> */}
          <Route exact path="/404" name="Page 404" element={<Page404 />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route path="*" element={<ProtectedRoute element={<DefaultLayout />} />} />
        </Routes>
      {/* </Suspense> */}
    </HashRouter>
  );
};

export default App;